module.exports = __webpack_public_path__ + "static/img/5d9b101dff0154d0575f9c6089a1f56c23cd1e5e7203-FPxWES_fw1200_1@2x.d4dcfa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/serviceImg/service/5d9b101dff0154d0575f9c6089a1f56c23cd1e5e7203-FPxWES_fw1200_1@2x.png
// module id = QK3L
// module chunks = 55